import React, { Component } from 'react';
import styles from './TenorTable.css';

class TableInputHeader extends Component {
  state = {
    showLoanLimitInfo: false,
    showInterestRateInfo: false,
  };

  render() {
    return (
      <div className={styles['table-header']}>
        <div className={styles['line-header']} />
        <div className={styles['header-content-wrapper']}>
          <p className={styles['text-header']}>Tenor</p>
          <div className={styles.line} />
          <div className={styles['info-header-wrapper']}>
            <p className={styles['text-header']}>Limit Pinjaman</p>
            <div className={styles['info-wrapper']}>
              <p
                className={styles.info}
                onMouseEnter={() => this.setState({ showLoanLimitInfo: true })}
                onMouseLeave={() => this.setState({ showLoanLimitInfo: false })}
              >
                i
              </p>
              {this.state.showLoanLimitInfo && (
                <div className={styles['info-loan-limit-content']}>
                  <p className={styles['info-title']}>Limit Pinjaman</p>
                  <p className={styles['info-desc']}>
                    Limit pinjaman dimulai dari Rp10 juta sampai Rp200 juta
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className={styles.line} />
          <p className={styles['text-header']}>Jumlah Pinjaman</p>
          <div className={styles.line} />
          <p className={styles['text-header']}>Bunga Flat / bulan</p>
          <div className={styles['info-wrapper']}>
            <p
              className={styles.info}
              onMouseEnter={() => this.setState({ showInterestRateInfo: true })}
              onMouseLeave={() =>
                this.setState({ showInterestRateInfo: false })
              }
            >
              i
            </p>
            {this.state.showInterestRateInfo && (
              <div className={styles['info-interest-rate-content']}>
                <p className={styles['info-desc']}>
                  Suku bunga: 1.19% - 1.49% flat per bulan sesuai dengan jumlah
                  pinjaman (atau setara dengan 2.07% - 2.63% bunga efektif per
                  bulan).
                </p>
              </div>
            )}
          </div>
          <div className={styles.line} />
          <p className={styles['text-header']}>Cicilan / bulan</p>
        </div>
      </div>
    );
  }
}

export default TableInputHeader;
